// @ts-ignore
import {createSelector} from 'reselect';
// @ts-ignore
import type {InputSelector, OutputSelector} from 'reselect';
// @ts-ignore
import * as ramda from 'ramda';
import type {User, Assignable} from '../types';
import {orderUsersAndTeams} from '../order-users-and-teams';
import {Users} from '../users';
import type {UsersState} from '../users';
import {Teams} from '../teams';
import type {TeamsState} from '../teams';

// The root state will include more keys, but this is what we really care about here
type AssignablesState = {
    users: UsersState;
    teams: TeamsState;
};

/**
 * Selector to get users and teams models, ordered in our nutshell opinionated way,
 * pushing disabled users and teams to the bottom of the list.
 *
 * @return {Object[]}                - Array of user and team models
 */

export const getAll: InputSelector<AssignablesState, undefined, Assignable[]> = createSelector(
    [Users.getById, Teams.getById],
    (usersById, teamsById) => {
        // @ts-ignore
        const users = ramda.values(usersById).filter((user) => !user.isHiddenFromFilters);
        const teams = ramda.values(teamsById);
        const assignables = [].concat(users).concat(teams);

        return orderUsersAndTeams(assignables);
    }
);

// @ts-ignore
export const getAllEnabled: OutputSelector<AssignablesState, undefined, Assignable[]> =
    createSelector([getAll], (assignables) => {
        // @ts-ignore
        return assignables.filter(
            // @ts-ignore
            (assignable) => assignable.isEnabled || assignable.type === 'teams'
        );
    });

// @ts-ignore
export const getAllEnabledUsers: OutputSelector<AssignablesState, undefined, User[]> =
    createSelector([getAll], (assignables) => {
        // @ts-ignore
        return assignables.filter(
            // @ts-ignore
            (assignable) => assignable.type === 'users' && assignable.isEnabled
        );
    });

// @ts-ignore
export const getAgents: OutputSelector<AssignablesState, undefined, User[]> = createSelector(
    [getAll],
    (assignables) => {
        // @ts-ignore
        return assignables.filter((assignable) => {
            return assignable.type === 'users' && assignable.isAgent;
        });
    }
);

// @ts-ignore
export const getAllUsers: OutputSelector<AssignablesState, undefined, User[]> = createSelector(
    [getAll],
    (assignables) => {
        // @ts-ignore
        return assignables.filter((assignable) => assignable.type === 'users');
    }
);

export const getEnabledUsersByPermission = (
    state: AssignablesState,
    permission: string
): User[] => {
    // @ts-ignore
    return getAllEnabledUsers(state).filter((user) => {
        return user.permissions[permission];
    });
};

export const getById: InputSelector<
    AssignablesState,
    undefined,
    {
        [id: string]: Assignable;
    }
> = createSelector([Users.getById, Teams.getById], (usersById, teamsById) => {
    // @ts-ignore
    return {...usersById, ...teamsById};
});

export const get = (state: AssignablesState, assignableId: string) => {
    return getById(state)[assignableId];
};
